<div class="wrapper">
  <div class="row">
    <div style="width: 100%; padding: 0% !important;">
      <h1 class="pageTitle">{{ pageTitle }}</h1>
      <app-notifications
        style="text-align: center"
        [notification]="'booking_details_page_notification_banner_child'"
      ></app-notifications>
      <div [innerHTML]="guidanceMsg"></div>
      <hr />
    </div>

    <div class="mt-4"  style="width: 100%; padding: 0% !important;">
      <div class="location-card">
        <button
          type="button"
          class="btn btn-primary"
          (click)="restartJourney()"
          title="Back"
          aria-label="Back to booking details"
        >
          <span
            ><fa-icon [icon]="faChevronLeft"></fa-icon
            ><span style="padding-left: 10px">{{
              'COMMON.RETURN' | translate
            }}</span></span
          >
        </button>
      </div>
    </div>
  </div>
</div>
<br />
<br />
